import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { ButtonSecondarySquareSmall } from "../generic/common/ButtonSecondarySquareSmall";
import { Icon } from "../generic/icon/Icon";
export var PlayerProfileSmallButton = React.memo(function (_a) {
    var disabled = _a.disabled, icon = _a.icon, onClick = _a.onClick;
    return (React.createElement(ButtonSecondarySquareSmall, { onClick: onClick, disabled: disabled },
        React.createElement("div", { className: "h100 w100 flex flex--guts" },
            React.createElement(Icon, { icon: icon, styleId: IdStyles.IconSmall }))));
});



//////////////////
// WEBPACK FOOTER
// ./src/features/player-profile/PlayerProfileSmallButton.tsx
// module id = 2881
// module chunks = 3